import React from 'react';
import {TimeSheetGroupType} from '../../../features/schedule/types';
import {setGroupBy} from '../../../features/schedule/slice';
import {useAppDispatch, useAppSelector} from '../../../hooks/hooks';

interface TimeSheetGroupByState {
    groupBy: TimeSheetGroupType;
    change: (value: TimeSheetGroupType) => void;
}

/**
 * Grouping mode of the timesheet grid.
 *
 * Backed by the store rather than component state so it survives the round trip to a
 * shift/absence form, the same way the timesheet filters do.
 */
export const useTimeSheetGroupBy = (): TimeSheetGroupByState => {
    const dispatch = useAppDispatch();
    const groupBy = useAppSelector((selector) => selector.timesheet.groupBy);
    const change = React.useCallback(
        (value: TimeSheetGroupType) => {
            dispatch(setGroupBy(value));
        },
        [dispatch]
    );

    return React.useMemo(() => ({ groupBy, change }), [change, groupBy]);
};
